const campaignDiscount = {
  inFlight: false,
  queued: false,

  init() {
    if (!window.ccCampaign?.active || !window.ccCampaign.code) return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.apply());
    this.apply();
  },

  async apply() {
    if (this.inFlight) {
      this.queued = true;
      return;
    }
    this.inFlight = true;

    try {
      const code = window.ccCampaign.code;
      const cart = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
      if (!cart.item_count) return;

      const existing = cart.discount_codes || [];
      const existingCodes = existing.map((discount) => discount.code);
      if (existingCodes.some((existingCode) => existingCode.toLowerCase() === code.toLowerCase())) return;

      const stateKey = `cc_campaign_skip:${cart.token}:${cart.item_count}:${cart.original_total_price}`;
      if (this.storage('get', stateKey)) return;

      const updated = await this.updateCodes([...existingCodes, code]);
      if (updated.rejected) {
        console.warn(`[campaign-discount] ${code} was rejected by the cart`);
        this.storage('set', stateKey);
        return;
      }
      if (!updated.cart) return;

      const applicable = (updated.cart.discount_codes || [])
        .filter((discount) => discount.applicable)
        .map((discount) => discount.code.toLowerCase());
      const keptCustomerCodes = existing
        .filter((discount) => discount.applicable)
        .every((discount) => applicable.includes(discount.code.toLowerCase()));
      if (applicable.includes(code.toLowerCase()) && keptCustomerCodes) {
        this.renderSections(updated.cart);
        return;
      }

      console.warn(`[campaign-discount] ${code} is not applicable to this cart or conflicts with an applied code`);
      this.storage('set', stateKey);
      const reverted = await this.updateCodes(existingCodes);
      if (reverted.cart) this.renderSections(reverted.cart);
    } catch (error) {
      console.warn('[campaign-discount]', error);
    } finally {
      this.inFlight = false;
      if (this.queued) {
        this.queued = false;
        this.apply();
      }
    }
  },

  async updateCodes(codes) {
    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        discount: codes.join(','),
        sections: [...new Set(this.getSectionsToRender().map((section) => section.section))],
        sections_url: window.location.pathname,
      }),
    });
    if (response.ok) return { cart: await response.json() };
    return { rejected: response.status === 400 || response.status === 422 };
  },

  getSectionsToRender() {
    return [...document.querySelectorAll('cart-items, cart-drawer-items')]
      .filter((element) => typeof element.getSectionsToRender === 'function')
      .flatMap((element) => element.getSectionsToRender());
  },

  renderSections(state) {
    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      const html = state.sections?.[section.section];
      if (!container || !html) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      const target = container.querySelector(section.selector) || container;
      if (source) target.innerHTML = source.innerHTML;
    });
  },

  storage(action, key) {
    try {
      return action === 'set' ? sessionStorage.setItem(key, '1') : sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  },
};

document.addEventListener('DOMContentLoaded', () => campaignDiscount.init());
